module.exports = __webpack_public_path__ + "static/media/4.Stand Drill.f708c0b7.jpg";